export default {
    translation: {
        common: {
            processing: 'データ処理中',
            loading: '読み込み中',
            here: 'こちら',
            navigationSearch: 'Search in English',
            forgotPassword: 'パスワードをお忘れですか？',
            approve: '承認する',
            reject: '却下する',
            confirmChanges: '一度OKを押すと元に戻せないのでご注意ください。',
            saveSuccessful: '保存完了',
            downloadCSV: '',
            resultsFilteredTo: 'バッグ名: {{name}}',
            folders: 'バッグ',
            select: '選択',
            unselect: '選択解除',
            mb: 'MB',
            removeUsers: 'ユーザーを削除する',
            bytes: 'バイト',
            unavailable: '無効',
            publidId: 'Public ID',
            title: 'タイトル',
            titleWithAsterisk: 'タイトル*',
            description: '内容',
            descriptionWithAsterisk: '内容*',
            location: '撮影地',
            locationWithAsterisk: '撮影地*',
            region: '地域',
            prefecture: '都道府県',
            prefectureWithAsterisk: '都道府県*',
            mediaSize: '画像サイズ',
            orientation: '画像比',
            expirationDate: '有効期限',
            secondaryUse: '二次利用可否',
            secondaryUseWithAsterisk: '二次利用可否*',
            secondaryUseJNTO: 'JNTOでの二次利用',
            secondaryUseJNTOWithAsterisk: 'JNTOでの二次利用*',
            secondaryUseJOMC: 'JOMCでの二次利用',
            secondaryUseMedia: 'メディア・旅行業界での二次利用',
            secondaryUseMediaWithAsterisk: 'メディア・旅行業界での二次利用*',
            secondaryUseJomcJnto: 'JOMCでの二次利用',
            secondaryUseJomcJntoWithAsterisk: 'JOMCでの二次利用*',
            secondaryUseGovernment: '自治体・省庁等での二次利用',
            secondaryUseGovernmentWithAsterisk: '自治体・省庁等での二次利用*',
            keywords: 'キーワード',
            information: '詳細',
            copywrite: 'コピーライト',
            widthAbbreviation: '縦',
            heightAbbreviation: '横',
            noRequestToDisplay: '申請依頼はありません',
            filesFinishedUploading: 'アップロードが完了しました',
            thumbnail: 'サムネイル',
            status: 'ステータス',
            notes: 'メモ',
            fileName: 'ファイル名',
            fileNameWithAsterisk: 'ファイル名*',
            csvFileName: '',
            photographer: '撮影者',
            requestApproval: '承認が必要です',
            approvalRequired: 'この素材をダウンロードするには承認が必要です',
            requestApprovalWithAsterisk: '承認が必要です*',
            shootingDate: '撮影日',
            shootingDateWithAsterisk: '撮影日*',
            from: '提供元',
            purchaseId: '購入先',
            validDate: '使用期限',
            credit: 'クレジット表記',
            creditWithAsterisk: 'クレジット表記*',
            contact: '問い合わせ先',
            copyrightHolder: '著作権保持者',
            collectionName: '事業名',
            contentfulId: 'Contentful ID',
            projectId: 'プロジェクト',
            projectIdWithAsterisk: 'プロジェクト*',
            caption: 'キャプション',
            prePostApprovalWithAsterisk: '事前利用許諾*',
            prePostApproval: '事前利用許諾',
            trimming: 'トリミング',
            trimmingWithAsterisk: 'トリミング*',
            rightOfPublicityWithAsterisk: '一般公開*',
            rightOfPublicity: '一般公開',
            myProfile: 'プロフィール',
            myFolders: 'フォルダ',
            myProjects: 'プロジェクト',
            myRequests: 'アップロードリクエスト',
            myPermissionRequests: 'リクエストをダウンロードする',
            moderation: 'モデレーション',
            admin: '管理',
            logout: 'ログアウト',
            uploadAssets: 'アップロードアセット',
            manualTags: 'マニュアルタグ',
            autoTags: 'オートタグ',
            search: '検索',
            imageGallerySearch: 'Search in English',
            next: '次へ',
            previous: '前へ',
            alt: 'Alt',
            organization: '組織',
            organizations: '組織',
            project: 'プロジェクト',
            projects: 'プロジェクト',
            user: 'ユーザー',
            users: 'ユーザー',
            userDelete: 'ユーザー削除',
            dimensions: 'ディメンション',
            fileSize: 'ファイルサイズ',
            width: '横',
            height: '縦',
            create: 'ユーザーを追加する',
            edit: '編集',
            remove: '除外',
            permissionMenu: '-ダウンロードのリクエスト-',
            uploadMenu: '-アセットをアップロードする-',
            adminMenu: '管理メニュー',
            details: '詳細',
            stepperRouteValidation: '現在のページのデータが失われる可能性があります、よろしいですか？',
            actionRequired: '必要なアクションがあります',
            copyrightWithAsterisk: '著作権*',
            modelRelease: 'モデルリリース',
            modelReleaseWithAsterisk: 'モデルリリース*',
            projectName: '事業名',
            projectNameWithAsterisk: "事業名*",
            secondaryUseMunicipality: '自治体での二次利用',
            secondaryUseMunicipalityWithAsterisk: '自治体での二次利用*',
            color: '明るさ・色味の補正',
            colorWithAsterisk: '明るさ・色味の補正*',
            text: 'テキストの組み合わせ',
            textWithAsterisk: 'テキストの組み合わせ*',
            contactOrganization: '連絡先の組織名',
            contactRole: '連絡先の役職',
            contactname: '連絡先の担当者名',
            duration:'動画尺',
            durationSeconds:"秒",
            contactPhoneNumber: '連絡先の電話番号',
            contactEmail: '連絡先のメールアドレス',
            attention: '注意',
            userGuide: 'User Guide',
            true: '可能',
            false: '不可',
            approvalNeededText: '利用許可申請',
            referenceUrl: "参考URL",
            remark: "備考",
            approvalForExternalUsage: "外部提供可否",
            approvalForExternalUsageWithAsterisk: "外部提供可否*",
            departmentInCharge: 'JNTO担当部',
            departmentInChargeWithAsterisk: 'JNTO担当部*',
            date: '更新順',
            reset: 'リセット',
            updateUser: 'ユーザー情報一覧',
            updateSuccess: '更新が完了しました。',
            updateSuccessSub: '更新した情報の反映には数分かかる場合があります。',
            // JOMC fields
            theme1: 'テーマ1',
            theme1WithAsterisk: 'テーマ1*',
            theme2: 'テーマ2',
            season: '季節',
            seasonWithAsterisk: '季節*',
            tags: 'タグ',
            mediaType: 'メディアタイプ',
            mediaTypeGovernment: 'メディアタイプ：政府',
            mediaTypeGovernmentWithAsterisk: 'メディアタイプ：政府*',
            mediaTypeMedia: 'メディアタイプ：メディア',
            mediaTypeMediaWithAsterisk: 'メディアタイプ：メディア*',
            mediaTypeTravelTrade: 'メディアタイプ：旅行業',
            mediaTypeTravelTradeWithAsterisk: 'メディアタイプ：旅行業*',
            location2: '地域',
            location2WithAsterisk: '地域*',
            availableJOMC: 'JOMCにも登録済み',
            viewMoreTags: 'View More Tags',
            viewMoreDetails: 'View More Details',
        },
        header: {
            dashboard: 'ダッシュボード',
            upload: 'アップロード',
            downloadRequest: '利用許可申請',
            userGuide: 'ユーザーガイド',
        },
        sideBar: {
            userInformation: '利用者情報',
            user: 'ユーザー:',
            email: 'メールアドレス:',
            organization: '組織:',
            userGroup: 'ユーザーグループ:',
            contact: 'お問い合わせ',
            pdf: 'マニュアル(PDF)',
            upload: {
                title: 'アップロード',
                option: 'アセットの登録先を選択',
                attachAsset: '素材をアップロードする',
                attachExcel: '素材情報の登録',
                upload: '素材情報の編集・確認',
            },
        },
        filters: {
            downloadCount: 'ダウンロード数',
            reset: '検索条件をリセット',
            filter: 'フィルター',
            assetType: '素材の種類',
            assetRatio: '画像比',
            prefecture: '都道府県',
            assetId: 'コンテンツ管理ID',
            assetIdTopBar: 'コンテンツ管理ID（一つだけ入力してください）',
            seasons: '季節',
            externalUse: '外部提供可否',
            externalUseApproved: '外部提供可',
            externalUseDenied: '外部提供不可',
            externalUseContact: 'JNTO担当部に確認',
            expireDateNo: 'なし',
            checkedExpireDateNo: '利用期間の制限: なし',
            checkedExpireDateYes: '利用期間の制限: あり',
            downloadPermission: '利用許可申請',
            downloadPermissionYes: '必要',
            downloadPermissionNo: '不要',
            downloadPermissionYesChecked: '利用許可申請: 必要',
            downloadPermissionNoChecked: '利用許可申請: 不要',
            prePostApproval: '事前利用許諾',
            prePostApprovalYes: 'あり',
            prePostApprovalNo: 'なし',
            prePostApprovalYesChecked: '事前利用許諾: あり',
            prePostApprovalNoChecked: '事前利用許諾: なし',
            expireDate: '利用期間の制限',
            tags: 'カテゴリー',
            image: '画像',
            video: '映像',
            portrait: '縦長',
            landscape: '横長',
            square: '正方形',
            spring: '春',
            summer: '夏',
            autumn: '秋',
            winter: '冬',
            allSeasons: 'オールシーズン',
            yes: '必要',
            no: '不要',
            enterAssetId: 'IDを入力してください',
            tag1: "Food and drink",
            tag2: "Shopping",
            tag3: "Historic sites",
            tag4: "Architecture",
            tag5: "Art",
            tag6: "Theme parks",
            tag7: "Cities",
            tag8: "Entertainment",
            tag9: "Subculture",
            tag10: "Fashion",
            tag11: "Tradition",
            tag12: "Skills and knowledge'",
            tag13: "Local lifestyle",
            tag14: "Festival",
            tag15: "Sports",
            tag16: "Outdoors",
            tag17: "Resorts",
            tag18: "Nature",
            tag19: "Nightlife",
            tag20: "Hot springs",
            hokkaido: '北海道',
            akita: '秋田',
            aomori: '青森',
            fukushima: '福島',
            iwate: '岩手',
            miyagi: '宮城',
            yamagata: '山形',
            chiba: '千葉',
            gunma: '群馬',
            ibaraki: '茨城',
            kanagawa: '神奈川',
            saitama: '埼玉',
            tochigi: '栃木',
            tokyo: '東京',
            fukui: '福井',
            ishikawa: '石川',
            nagano: '長野',
            niigata: '新潟',
            toyama: '富山',
            aichi: '愛知',
            gifu: '岐阜',
            mie: '三重',
            shizuoka: '静岡',
            yamanashi: '山梨',
            hyogo: '兵庫',
            kyoto: '京都',
            nara: '奈良',
            osaka: '大阪',
            shiga: '滋賀',
            wakayama: '和歌山',
            hiroshima: '広島',
            okayama: '岡山',
            shimane: '島根',
            tottori: '鳥取',
            yamaguchi: '山口',
            ehime: '愛媛',
            kagawa: '香川',
            kochi: '高知',
            tokushima: '徳島',
            fukuoka: '福岡',
            kagoshima: '鹿児島',
            kumamoto: '熊本',
            miyazaki: '宮崎',
            nagasaki: '長崎',
            oita: '大分',
            saga: '佐賀',
            okinawa: '沖縄',
            foodDrink: 'Food and drink',
            shopping: 'Shopping',
            historicSites: 'Historic sites',
            architecture: 'Architecture',
            art: 'Art',
            themeParks: 'Theme parks',
            cities: 'Cities',
            entertainment: 'Entertainment',
            subculture: 'Subculture',
            fashion: 'Fashion',
            tradition: 'Tradition',
            skillsKnowledge: 'Skills and knowledge',
            localLifestyle: 'Local lifestyle',
            festival: 'Festival',
            sports: 'Sports',
            outdoors: 'Outdoors',
            resorts: 'Resorts',
            nature: 'Nature',
            nightlife: 'Nightlife',
            hotSprings: 'Hot springs',
            fuzzySearch: 'あいまい検索',
            tooptipFuzzy: "あいまい検索とは？",
            tooptipFuzzyDetail: "検索したいキーワードと完全に一致しなくても、類似した結果を見つけ出し結果として表示してくれます。例えば、スペルミスや同義語、関連語を含む検索においても、関連する情報を提供することができます。",
            tooptipKeyword: "検索できるキーワード",
            tooptipKeywordDetail: "検索可能なキーワードには、アセットのメタデータに保存されているさまざまな情報が含まれています。例えば、アセットに付与したタグ、アセットの説明、撮影地等が含まれます。",
        },
        auth: {
            signin: {
                noAccount: 'アカウントを作成する',
                welcomeBack: 'おかえりなさい！'
            },
            signup: {
                alreadyHaveAccount: 'サインインする',
                signupHere: '新規アカウントはこちら',
            },
            forgotPassword: {
                backToSignin: 'サインイン画面に戻る',
                resetPassword: 'パスワードのリセット',
            }

        },
        termsAndConditions: {
            termsAndConditions: '利用規約',
            agreedToTerms: '利用規約に同意する',
            download: {
                downloadTerms: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum vel libero ac quam pulvinar blandit. Mauris varius nisi et augue vehicula vulputate. Ut volutpat molestie quam. Pellentesque urna elit, feugiat id ante quis, sodales fermentum arcu. Nam pellentesque eleifend ligula, at interdum risus tincidunt et. Suspendisse sit amet urna nec purus tempor luctus non nec felis. Nullam eget aliquam sapien. Proin eleifend nulla nec tortor venenatis, ac egestas augue mollis. Curabitur sed justo bibendum, tempor nibh a, faucibus arcu. Nulla sit amet urna quis velit sollicitudin dignissim. Mauris volutpat rhoncus velit, rutrum finibus enim posuere eu. Duis accumsan ex velit, molestie finibus nibh dignissim ut. Nunc malesuada luctus sem. Donec luctus dolor ac ipsum iaculis faucibus. Pellentesque in purus eget est maximus sollicitudin. Morbi eget tempus mauris. Sed mauris mi, aliquam at leo quis, scelerisque ultrices turpis. Suspendisse vulputate dui non ante finibus, efficitur vulputate magna finibus. Quisque at elementum risus. Curabitur lacinia dui magna, at accumsan velit ultrices id. Mauris tempor imperdiet est in varius. Sed diam sapien, placerat ac eleifend a, sollicitudin ornare ipsum. Aenean lacinia ipsum eget orci tincidunt, vitae eleifend ipsum varius. Proin turpis turpis, faucibus at consequat in, interdum rhoncus magna. Duis quis nisi hendrerit, faucibus justo eu, ultricies justo. Cras in tortor est. Mauris mattis pellentesque orci. Pellentesque semper eros eget ornare facilisis. Nulla in nulla nec nisi blandit laoreet. Cras nec odio imperdiet, auctor nibh at, sollicitudin ante. Donec metus diam, vehicula vel leo nec, mattis efficitur nisi. Morbi luctus augue lorem, non gravida tellus fringilla at. Nullam id pharetra diam, nec scelerisque purus. Praesent sed eleifend leo. Fusce elementum ante id odio finibus, eget iaculis diam iaculis. Maecenas quis vestibulum mauris. Aenean justo sapien, porta at volutpat eleifend, interdum ut tellus. Quisque commodo, elit vitae lobortis commodo, lacus tortor volutpat eros, hendrerit semper nibh massa quis enim. Fusce ut gravida lectus. Suspendisse potenti. Pellentesque posuere odio nibh. Phasellus suscipit, tortor sollicitudin rhoncus gravida, eros sem tempus ex, sit amet fringilla nulla lorem a ligula. Maecenas vitae odio in velit auctor rutrum et id dolor. Aliquam at ultrices nulla. Vestibulum sed pretium erat. Ut feugiat condimentum urna a vehicula. Proin arcu mi, vestibulum et augue eget, fringilla ultrices ligula. Proin molestie vestibulum purus at faucibus. Fusce sapien est, varius a hendrerit sit amet, dictum vel nisl. Etiam ac augue semper, finibus odio quis, porttitor tortor. Aliquam ut orci vel eros pellentesque hendrerit. Maecenas rhoncus libero arcu, eget consectetur neque elementum ut. Nulla rutrum porta volutpat.',
                downloadAgree: ' 利用規約に同意する',
            }
        },
        faq: {
            faqcategory1: '一般',
            faqcategory2: 'アップロード',
            faqcategory3: 'ダウンロード',
            faqQuestion1: 'Q: JNTO Photo & Video Libraryとは何ですか？',
            faqAnswer1: 'A: JNTO Photo & Video Libraryとは、デジタル素材(画像や動画)を一元管理・共有するシステムです。',
            faqQuestion2: 'Q: デジタル素材とは何ですか？',
            faqAnswer2: 'A: An asset is a file such as a video, music, photo, documents, etc. which contain the rights to use them.',
            faqQuestion3: 'Q: お問い合わせ窓口に連絡するにはどうすればいいですか？',
            faqAnswer3: 'A: お問い合わせは電話またはメールで可能です。詳細は以下の通りです。\n Tel: 03-6804-2655 \n Email: jphoto-inquiry@jnto.go.jp',
            faqQuestion4: 'Q: 私の組織の設定を管理しているのは誰ですか？',
            faqAnswer4: 'A: 管理者は各組織の設定を管理しています。',
            faqQuestion5: 'Q: 管理者に問い合わせる方法はありますか？',
            faqAnswer5: 'A: ',
            faqQuestion6: 'Q: My バッグとは何ですか？作成方法が知りたいです。',
            faqAnswer6: 'A: My バッグは、使用する予定の素材をフォルダーのように管理したり、複数の素材を一括ダウンロードするために使用します。My バッグの作成方法については、ユーザーガイドを参照してください。',
            faqQuestion7: 'Q: 素材をアップロードする方法が知りたい',
            faqAnswer7: 'A: アップロードの手順については、ユーザーガイドを参照してください。',
            faqQuestion8: 'Q: アップロードできる素材の形式は？',
            faqAnswer8: 'A: 画像 (jpeg, jpg, png, etc) と動画 (mp4)のアップロードが可能です。',
            faqQuestion9: 'Q: 素材情報とは何ですか？',
            faqAnswer9: 'A: 素材情報とは素材それぞれの「ファイル名」や「撮影地」、「二次利用許可の有無」などの情報を指します。',
            faqQuestion10: 'Q: 素材情報に出てくる「タグ」と「メタデータ」の違いは何ですか？',
            faqAnswer10: 'A: 「タグ」は素材の特徴やカテゴリーなどで検索する際用いる情報を指しています。メタデータは「素材情報」そのものを指します。',
            faqQuestion11: 'Q: アップロードした画像が表示されません。どうすれば良いですか。',
            faqAnswer11: 'A: ファイルサイズにもよりますが、アップロードされたアセットがライブラリに表示されるまでに時間がかかります。時間が経っても表示されない場合は、サポートまでご連絡ください。\Tel: 03-6804-2655 \n Email: jphoto-inquiry@jnto.go.jp',
            faqQuestion12: 'Q: アップロード用の「素材情報」を準備するにはどうすれば良いですか。',
            faqAnswer12: 'A: 詳しくはユーザーガイドをご覧ください。',
            faqQuestion13: 'Q: アップロード用の「素材情報」のエクセルテンプレートはどこにありますか？',
            faqAnswer13: 'A: アップロードページ「3. 画像・映像リスト情報の登録」の「素材ファイルのダウンロード」で確認することができます。',
            faqQuestion14: 'Q: 素材をダウンロードすることは可能ですか？',
            faqAnswer14: 'A: はい、アセットのダウンロードは可能です。アセットには、無料でダウンロードするものと許可を得てダウンロードするものがありますので、ご注意ください。詳しくは、ダウンロードの流れを詳しく説明したユーザーガイドをご覧ください。',
            faqQuestion15: 'Q: 画像がダウンロードできません。どうすればいいですか？',
            faqAnswer15A: 'A: バグ報告機能をご利用ください。',
            faqAnswer15B: 'すでにウィンドウを閉じている場合は、ダッシュボードページの「問題を報告」オプションをご利用ください。',
            faqAnswer15C: '上記の2つのオプションを使用して問題が発生した場合は、サポートチームに直接お問い合わせください。 \n Tel: 03-6804-2655 \n Email: jphoto-inquiry@jnto.go.jp',
            faqQuestion16: 'Q: 利用許可の申請が必要な素材をダウンロードするにはどうすればいいですか？',
            faqAnswer16: 'A: 利用許可の申請をして画像をダウンロードする方法については、ユーザーガイドを参照してください。',
        },
        workflows: {
            admin: {
                userAdmin: 'ユーザー管理',
                userName: '氏名',
                loading: '読み込み中',
                editSuccess: 'User edit has been completed', 
                email: 'メールアドレス',
                editUserModalTitle: '編集する',
                organization: '所属部署',
                projectAdmin: 'プロジェクト管理',
                organizationAdmin: '組織管理',
                createUser: 'ユーザーを作成する',
                editUser: '編集する',
                viewAllUser: 'ユーザー情報一覧',
                removeUser: 'ユーザーを削除する',
                deleteUserConfirm: 'ユーザーを削除しますか？',
                createProject: 'プロジェクトを作成する',
                createOrganization: '組織を追加する',
                selectSupervisorOrganization: '組織管理者を選択',
                selectUserGroup: 'ユーザーグループを選択',
                projects: 'プロジェクト',
                userGroup: 'ユーザーグループ',
                supervisorOrganization: '組織管理者',
                userCreateSuccess: 'ユーザーの作成が完了しました',
                userRemovalSuccess: 'ユーザーを削除しました',
                organizationCreateSuccess: '組織の作成が完了しました',
                projectCreateSuccess: '新規プロジェクトの作成が完了しました',
                editOrganizationProjects: '組織のプロジェクトを編集する',
                updateOrganization: '組織を編集する',
                selectAnOrganization: '組織を選択してください',
                removeOrganization: '組織を除外する',
                reset: '入力情報をリセットする'
            },
            moderation: {
                approveOrReject: '承認または却下された申請一覧はこちら',
                approveSelected: '承認された選択済のアップロード素材',
                rejectSelected: '却下された選択済のアップロード',
            },
            fileupload: {
                selectOptionTitle: '1. 画像・映像の登録先を選択',
                selectOptionQuestion1: '1. アップロードする素材はJOMC(Japan Online Media Center)にも登録しますか？',
                selectOptionQuestion1Answer1: 'いいえ。JNTO Photo & Video Libraryにのみ登録します。',
                selectOptionQuestion1Answer2: 'はい。JOMC(Japan Online Media Center)にも登録します。\n※JOMCに登録すると外部ユーザーがダウンロード可能になります。',
                selectOptionQuestion2: '2. 素材の入手元を選んでください。',
                selectOptionQuestion2Answer1: 'JNTO',
                selectOptionQuestion2Answer2: '第三者機関（自治体など）',
                selectOptionQuestion3: '第三社機関のグループを選択してください。',
                selectOptionQuestion3DefaultDropDown: 'グループを選択',
                selectOptionQuestion3Group1: '1 (都道府県)',
                selectOptionNotesTitle: '注意！',
                // selectOptionNotes1: '「アップロード」に関する詳しい操作方法はユーザーガイドをご確認ください→ ユーザーガイド',
                attachAssetsTitle: '2. 画像・映像をアップロードする',
                reviewUploads: 'アップロードする素材の内容をご確認ください',
                maximumFileSize: '・アップロードが可能なファイルサイズは、1画像につき最大300MB、1映像につき最大1000MB',
                canUploadImagesAndVideos: '・画像素材と映像素材の同時アップロードが可能',
                attachAssetsNotes1: '・アップロードが可能な素材形式: JPG, JPEG, PNG, MP4.',
                attachAssetsNotes2: ' ・素材が格納されているフォルダーを圧縮したZipファイル形式でのアップロードが可能',
                attachAssetsNotes3: "・アップロード1回あたりの容量は5000MB以内",
                attachAssetsNotes4:"・連続してアップロードする場合は10分程度間隔をあける",
                attachExcelFileTitle: '3. 画像・映像リスト情報の登録',
                attachExcelFileNote1: '・「画像・映像リスト」をアップロードしてください',
                attachExcelFileNote2: '・アップロードする画像・映像リストのファイル名と、前画面でアップロードした素材ファイル名は、一致している必要があります',
                attachExcelFileNote3: '',
                uploadAssetsTitle: '4. 素材情報の編集',
                uploadScrollNotes: '下のグリッドでは横方向にスクロールすることができます。',
                uploadAssetsNotes: '前画面でアップロードした画像・映像リスト情報を編集できます。\n（* 必須項目）横方向にスクロールすることができます。',
                uploadAssetsNotes2: ' エラーが発生した場合は、下記の項目に誤りがないかご確認ください。',
                uploadAssetsNotes3: '・アップロードする画像・映像リストのファイル名と、前画面でアップロードした素材ファイル名は、一致しているか',
                uploadAssetsNotes4: '・ファイル名にスペースが入力されていないか',
                uploadAssetsNotes5: '・プルダウンから選択する項目にもかかわらず、手入力になっていないか',
                uploadAssetsNotes6: '・必須項目が空欄になっていないか',
                uploadAssetsNotes7: '・半角英数字で入力すべき項目にもかかわらず、全角で記入していないか',

                referToUserGuide: '「アップロード」に関する詳しい操作方法はユーザーガイドをご確認ください→ ',
                downloadTemplateJNTO: '「画像・映像リスト」のテンプレートをダウンロード (JNTO)',
                downloadTemplateJOMC: '「画像・映像リスト」のテンプレートをダウンロード (JNTO Photo & Video Library&JOMC)',
                restartUpload: 'アップロード作業をやり直す',
                myPendingRequests: '保留中の申請一覧',
                hoverText: '画面上で追加/編集した最新のファイルをここからダウンロードできます。アップロードする前に一時的にファイルを保存したい方はご利用ください。',
                downloadGrid: '作業ファイルのダウンロード',
                validation: {
                    filename: 'ファイル名を正しく入力してください',
                    location: '撮影地を正しく入力してください',
                    prefecture: '都道府県を正しく入力してください。都道府県名はローマ字で、先頭が大文字である必要があります',
                    description: '内容を正しく入力してください',
                    photographer: '撮影者の名前を正しく入力してください',
                    requestApproval: '承認が必要なものは「Yes」不要な場合は「No」を入力してください',
                    shootingDate: '撮影日を正しく入力してください。正しいフォーマット「YYYMMDD」、「YYYYMM」または「YYYY」で記入する必要があります。例）20201231',
                    from: '提供元を正しく入力してください',
                    purchaseId: '素材IDを正しく入力してください',
                    projectName: "事業名を正しく入力してください",
                    validDate: '有効期限を正しく入力してください。正しいフォーマット「YYYMMDD」で記入する必要があります。例）20201231',
                    prePostApproval: '事前利用承諾が必要なものは「Yes」、不要な場合は「No」を入力してください',
                    secondaryUseJNTO: 'JNTOでの二次利用を許可する場合は「Yes」、許可しない場合は「No」を入力してください',
                    secondaryUseMedia: 'メディアでの二次利用を許可する場合は「Yes」、許可しない場合は「No」を入力してください',
                    secondaryUseJomcJnto: 'JOMCでの二次利用を許可する場合は「Yes」、許可しない場合は「No」を入力してください',
                    secondaryUseGovernment: '行政での二次利用を許可する場合は「Yes」許可しない場合は「No」を入力してください',
                    secondaryUseJOMC: 'JOMCでの二次利用を許可する場合は「Yes」、許可しない場合は「No」を入力してください',
                    trimming: 'トリミングを許可する場合は「Yes」、許可しない場合は「No」を入力してください',
                    credit: 'クレジット表記を正しく入力してください',
                    rightOfPublicity: '一般公開を許可する場合は「Yes」、許可しない場合は「No」を入力してください',
                    contact: '問い合わせ先を正しく入力してください',
                    title: 'タイトルを正しく入力してください。JOMCに登録する場合、入力が必須な項目です。',
                    theme1: 'テーマ1を正しく入力してください。JOMCに登録する場合、入力が必須な項目です。',
                    theme2: 'テーマ2を正しく入力してください。JOMCに登録する場合、入力が必須な項目です。',
                    season: '季節を正しく入力してください。JOMCに登録する場合、入力が必須な項目です。',
                    tags: 'タグ名を正しく入力してください。',
                    mediaType: 'メディアタイプを正しく入力してください。JOMCに登録する場合、入力が必須な項目です。',
                    copyright: '著作権の保証をする場合は「Yes」、しない場合は「No」を入力してください',
                    modelRelease: '肖像権の保証をする場合は「Yes」、しない場合は「No」を入力してください',
                    secondaryUseMunicipality: '自治体での二次利用を許可する場合は「Yes」、しない場合は「No」を入力してください',
                    color: '明るさ、コントラスト比、トーン、色味等を補正して利用することを許可する場合は「Yes」、しない場合は「No」を入力してください',
                    text: 'テキストの組み合わせて利用することを許可する場合は「Yes」、しない場合は「No」を入力してください',
                    contactOrganization: '連絡先の組織を正しく入力する必要があります',
                    contactRole: '連絡先の役職を正しく入力する必要があります',
                    contactname: '連絡先の担当者名を正しく入力する必要があります',
                    contactPhoneNumber: '連絡先の電話番号を正しく入力する必要があります',
                    contactEmail: '連絡先のメールアドレスを正しく入力する必要があります',
                    location2: '地域を正しく入力してください。JOMCに登録する場合、入力が必須な項目です。',
                    mediaTypeGovernment: '公的機関による利用を許可する場合は「Yes」、しない場合は「No」を入力してください',
                    mediaTypeMedia: 'メディアによる利用を許可する場合は「Yes」、しない場合は「No」を入力してください',
                    mediaTypeTravelTrade: '旅行代理店による利用を許可する場合は「Yes」、しない場合は「No」を入力してください',
                    mediaTypeMultiple: 'JOMCに登録する場合、いずれかのメディアタイプでの利用が許可れている必要があります',
                    secondaryUseMultiple: 'JOMCに登録する場合、旅行代理店またはメディアでの利用が許可されている必要があります',
                    approvalForExternalUsage: '外部提供可否を正しく入力してください',
                    remark: '備考を正しく入力してください',
                    referenceUrl: '参考URLを正しく入力してください',
                    departmentInCharge: 'JNTO担当部を正しく入力してください',
                },
                successModal: {
                    title: 'アップロード完了',
                    bodyText1: 'アップロードが完了しました。保存された素材を確認する場合はこちら から。続けて素材をアップロードされる場合はこちらから登録してください。',
                    bodyText2: '*登録した素材の範囲には通常1,2分程度、大きなファイルサイズの素材(動画等)によっては5分以上。時間がかかりますのでご了承ください。',
                    button: 'この画面を閉じてダッシュボードへ移動する'
                }
            },
            folders: {
                deleteFromBag: 'バッグから削除する',
                downloadWarning: 'このバッグには、利用許可申請が必要な素材が含まれています。 \nダウンロードをクリックすると、申請が不要なアセットのみダウンロードされます。 \n※利用許可申請は、「利用許可を申請する」から申請を行ってください。',
                areYouSure: '本当に実行しますか？',
                renameFolder: 'バッグ名を変更',
                deleteFolderPrompt: 'バッグを削除しますか？',
                downloadFolder: 'バッグをダウンロードする',
                deleteFolder: 'バッグを削除する',
                newFolderName: '新しいバッグ名',
                searchWithinFolder: 'バッグの中から素材を探す: {{folderName}}',
                requestPermission: 'すべての素材の使用許可を申請する',
                folderUse: 'Use: {{folderUse}}',
                folderHasPermissionImage: '利用許諾画像あり',
                back: '戻る'
            },
            myRequests: {
                reviewRequests: '申請内容の確認をしてください',
                tabLabels: {
                    rejected: '却下されました',
                    pending: '保留中です',
                    approved: '承認されました'
                },
            },
            myPermissionRequests: {
                deletePermissionsConfirm: '利用許可申請をキャンセルすると、このバッグに対するすべての許可要求が削除されます。\nこのフォルダに関連付けられた要求の種類と理由が削除されます、現在承認されている画像は、再度承認する必要があります。\n個別の素材に対してのみ申請のキャンセルを行いたい場合は、対象素材ををこのバッグから削除してください。 ',
                deleteAssetFromFolder: 'バッグから素材を削除する場合、このバッグ内で発行した利用許可申請が削除されます。',
                pendingRequests: '保留中の使用許可申請一覧',
                requestUserOrg: '申請したユーザーの組織名',
                requestUser: '申請したユーザー名',
                requestReason: '利用法の説明',
                status: 'ステータス',
                reviewRequests: '申請中の利用許可一覧',
                approveSelected: '選択した申請を承認する',
                title: '利用タイプ',
                rejectSelected: '選択した申請を却下する',
                approveSelectedMessage: '選択した申請内容に対し、利用許可が承認されます。操作の取り消しはできません。- 実行しますか?',
                rejectSelectedMessage: '選択した利用許可の申請を却下します。操作の取り消しはできません。- 実行しますか?',
                fromUser: '申請者名',
                fromEmail: '申請者メアド',
                fromOrganization: '申請者所属',
                useType: '利用タイプ',
                usageDescription: '利用法の説明をご記入ください',
                modalTitleExisting: '利用タイプ：',
                downloadUse: '利用タイプ：{{reason}}',
                selectFolder: '新規または既存のバッグに追加',
                folderDetail: '素材をいれるバッグを新規作成するか、既存のバッグに入れてください',
                usageReasonEnterTitle: '利用許可の申請を行います',
                usageReasonEnter: '利用タイプ:',
                downloadDetails: '利用法の説明: {{reason}}',
                couldNotDownloadNoUsers: 'アップロードする組織にユーザーが存在しないため、次の素材をダウンロードできません',
                modalReasonExisting: '利用法の説明',
                tabLabels: {
                    incoming: '受信した利用許可申請の一覧',
                    outgoing: '申請した利用許可の一覧'
                },
                uses: {
                    sns: '①SNSでの情報発信',
                    website: '②WEBサイトでの情報発信',
                    newsletter: '③ニュースレターでの情報発信',
                    events: '④イベント(旅行博・商談会・セミナー等)での活用',
                    invitation: '⑤旅行会社・メディア・インフルエンサー招請',
                    advertising: '⑥広告宣伝',
                    other: '⑦その他',
                    commercial: '商用目的',
                    noncommercial: '非商用目的',
                }
            },
            downloadHistory: {
                downloadStartDate: '開始日: ',
                downloadEndDate: '終了日: ',
                downloadExcel: 'ダウンロード履歴を抽出する',
                viewHistoriesAdmin:'全ての組織がアップロードしたアセットのダウンロード履歴',
                viewHistories: '組織がアップロードしたアセットのダウンロード履歴',
                downloadHistories: 'ダウンロード履歴',
                uploader: 'アップローダー',
                downloader: 'ダウンローダー',
                uploadOrg: 'アップローダーの組織',
                downloadOrg: 'ダウンローダーの組織',
                downloadDate: 'ダウンロード日付',
                downloadSizeWarning: 'ダウンロードサイズが4GBを超えています。続行しますか？',
                noRequests: '履歴はありません'
            },
            deletionSystem: {
                delete: '削除',
                confirmTitle: '本当に削除を実行しますか?',
                confirmText: '素材を削除しようとしています。操作の取り消しはできません。\n 実行しますか?',
                infoText: '*削除が完了するまでに数分かかる場合があります。その後、変更が反映される為ページを更新が必要です。',
                confirmTextJOMC: '注意: 素材はJOMC(Japan Online Media Center)にも登録されています。削除を実行するとどちらの素材も削除します。 \n\n操作の取り消しはできません。\n 実行しますか?'
            },
            userProfile: {
                yourProfile: 'ユーザーのプロフィール',
                selectLanguage: '言語設定',
                preferences: 'ユーザー設定',
                information: 'ユーザープロフィール',
                creationDate: '作成日:',
                signInAs: 'ユーザーグループ:',
                email: 'メールアドレス:',
            },
            projects: {
                tagEdit: "タグ「{{tagName}}」を削除してよろしいですか？",
                addToBag1: '選択した素材をバッグに入れる',
                addToBag2: '素材を入れるバッグを新規作成するか既存のバッグに入れてください。',
                addBagDropDown: '新規または既存のバッグに追加',
                addBagSubmit: '保存',
                numberOfAssets: '選択されたアセット数:{{count}}',
                selectFolder: 'バッグを選択してください',
                addNewFolder: '新しいバッグを追加する',
                addUploadFolder: 'アップロードフォルダを追加する',
                selectProject: 'プロジェクトを選択',
                selectProjectToProceed: '**プロジェクトを選択して続行してください',
                numberOfAssetsReturned: '検索結果： {{count}} / {{totalCount}}',
                numberOfImagesReturned: '画像: {{totalImages}}件中 {{imageCount}}件表示',
                numberOfVideosReturned: '動画: {{totalVideos}}件中 {{videoCount}}件表示',

                searchAcrossProjects: '全体のプロジェクトから素材を探す',
                searchWithinProject: 'プロジェクト内から素材を探す: {{projectName}}',
                selectProjectToViewAssets: 'プロジェクトから素材を探す',
                copiedAssetUrl: '素材のURLをコピーしました。URLの取り扱いご注意ください。'
            }
        },
        form: {
            label: {
                firstName: '名',
                lastName: '姓',
                email: 'メールアドレス',
                phoneNumber: '電話番号',
                projectName: 'プロジェクト名',
                organizationName: '組織名',
                password: 'パスワード',
                passwordRules: 'パスワードは最低１２文字で小文字・大文字・特殊文・数字を１ずつ入れてください。特殊文字は以下の通りです：= + - ^ $ * . [ ] { } ( ) ? " ! @ # % & /   \\ , > <    \' : ; | _ ~ `',
                verificationCode: '確認コード',
                newPassword: '新しいパスワード',
                submit: '送信',
                create: '作成',
                ok: 'OK',
                cancel: 'キャンセル',
                next: '次へ',
                back: '戻る',
                save: '保存',
                deletePermissions: '利用許可申請をキャンセル',
                download: 'ダウンロード',
                searchForAssets: '素材を探す',
                editFilesHere: '編集する',
                dragDropFilesHere: 'ドラッグ＆ドロップされたフォルダはこちら',
                selectProject: '選択されたプロジェクト',
                selectProjectDescription: 'アップロードするファイルのプロジェクトを選択してください',
                selectProjects: 'プロジェクトを選択',
                attachAssets: '素材を添付',
                attachAssetsDescription: 'アップロードする素材を選択',
                attachCSV: '',
                attachCSVDescription: '',
                uploadAssets: 'アップロードされた素材',
                uploadAssetsDescription: '',
                selectAnOrganization: '組織を選択',
                numProjectsSelected: 'プロジェクトを選択',
                refresh: '更新',
                addTag: 'タグを追加',
                close: '閉じる',
                requestApproval: '利用許可を申請する'
            },
            placeholder: {
                enterTag: 'タグを追加し、Enterを押してください'
            },
            errors: {
                errorTitle: 'エラーが発生しました',
                errorPopupMessage: '再度お試し頂くか、問題が解決しない場合はお問い合わせ窓口にご連絡ください。',
                email: '有効なメールアドレスを入力してください',
                verificationCode: '正しい認証コードを入力してください',
                phoneNumber: '有効な電話番号を入力してください',
                firstName: '名字を入力してください',
                lastName: '名前を入力してください',
                projectName: 'プロジェクト名を入力してください',
                organizationName: '組織名を入力してください',
                password: '有効なパスワードを入力してください',
                signinFail: '登録に失敗しました。再度お試し頂くか、お問い合わせ窓口にご連絡ください',
                createUserFail: 'ユーザーの作成に失敗しました。再度お試し頂くか、お問い合わせ窓口にご連絡ください',
                removeUserFail: 'ユーザーの削除に失敗しました。再度お試し頂くか、お問い合わせ窓口にご連絡ください',
                createOrganizationFail: '組織の作成に失敗しました。再度お試し頂くか、お問い合わせ窓口にご連絡ください',
                createProjectFail: 'プロジェクトの作成に失敗しました。再度お試し頂くか、お問い合わせ窓口にご連絡ください',
                passwordCouldNotBeReset: 'パスワードのリセットに失敗しました。再度お試し頂くか、お問い合わせ窓口にご連絡ください',
                attachValidExcel: 'アップロードしたファイル形式に誤りがあります。\n エクセルファイルをアップロードしてください。',
                noAssetsFound: '素材が見つかりませんでした',
                requestFailed: '申請中にエラーが発生しました。再度お試し頂くか、お問い合わせ窓口にご連絡ください',
                disallowedFileUpload: '許可されていないファイル形式です: ({{invalidFile}})',
                invalidZipArchive: 'アップロードが可能な素材形式: JPG, JPEG, PNG, MP4.',
                contactSupport: '窓口へ問い合わせる'
            }
        },
        locale: {
            english: '英語',
            japanese: '日本語'
        },
        manual: {
            welcomePage: {
                menuHeader: '概要',
                title: '1. 概要',
                body: 'JNTO Photo & Video Library（デジタルアセット管理）アプリケーションは、JNTOプロジェクトで協⼒して下さっている官公庁、\n地⽅⾃治体の皆様にデジタルアセットの保存、取込、および管理する場を提供するために構築されました。',
                concept: 'JNTO Photo & Video Library（デジタルアセット管理）アプリケーションには、関連する4つの主要な⽤語があります。',
                conceptDetail1: '1. 組織 - JNTO Photo & Video Libraryの利⽤は特定の事業またはJNTOおよび官公庁・地⽅⾃治体の組織単位で許可されます。組織によってアクセスできる領域が異なります。',
                conceptDetail2: '2. ユーザー - 存在する組織のメンバーを指します。ユーザーは一般または管理者どちらかの権限が付与されます。ユーザーは1つの組織にしか属せません。',
                conceptDetail3: '3. 素材 - 素材とはJNTO Photo & Video Library上で管理される画像(jpeg, png, jpg etc) あるいはビデオ(mp4)を指します。',
                conceptDetail4: '4. イメージギャラリー - JNTO Photo & Video Libraryで管理される全ての素材の格納場所です。',
                concept2: '素材の活用範囲・利用方法について',
                concept2Detail1: '1. 格納されている画像・映像は原則JNTO事業に限り利用可能です。但し、JNTO職員経由で第三者に提供可能な画像・映像も2022年度に一部格納されました。',
                concept2Detail2: '2. 権利処理を実施した担当部に個別確認が必要になるケースがございます。ご注意ください。',
                concept2Detail3: '3. JNTO内限定の素材が流出しないようご注意願います。',
                concept2Detail4: '4. 各素材の権利処理情報(トリミングの可否等)については、各素材の情報を確認の上、ご利用ください。',
            },
            userAuth: {
                menuHeader: 'ログイン関連',
                title: '2 ログイン関連',
                body: 'JNTO Photo & Video Libraryシステムにログインできるようにするには、ユーザーはすでにアカウントを持っている必要があります。\nユーザーのアカウントは管理者が作成できます。ユーザーアカウントの作成の詳細については、XXXページを参照してください。'
            },
            login: {
                menuHeader: 'ユーザーログイン',
                subTitle: '2. ログイン関連',
                title: '2.1 ユーザーログイン',
                loginDetailnew1: 'JNTO photo & video libraryにログインするには、アカウントを作成する必要があります。 アカウントは管理者権限を持つユーザーのみ作成可能です。 新規アカウントの発行が必要な場合、日本政府観光局企画総室デジタルマーケティングセンターへお問い合わせください。',
                loginDetail1a: '以下URLからJNTO photo & video libraryにログインが可能です',
                loginDetail1b: '初期パスワードはアカウント発行時に、システム(no-reply@verificationemail.com)から送信されるメールにてご確認ください。',
                loginDetail1c: 'なおJNTOが別途運用するJapan Online Media Center(https://business.jnto.go.jp/)において、 すでにアカウントを保持しており、J-photoのアカウントをお持ちの場合は、同じパスワードを使用してJNTO photo & video libraryにログインすることが可能です。',
                loginDetail1d: 'アカウントを再登録する必要があり ますので、jphoto-inquiry@jnto.go.jp までご連絡ください',
                title2: '言語設定の変更',
                loginDetail2a: '画面右上のユーザープロフィールアイコンをクリックすると、下記のようなユーザープロフィール ページが表示されます。ここでは、ユーザーの氏名、登録メールアドレス、ユーザーグループ(組 織名)を確認することができます。',
                loginDetail2b: '「ユーザー設定」のタブを開くと下記のページが表示されます。「言語設定」から言語を 選択し、変更することが可能です。',

            },
            resetPassword: {
                menuHeader: 'リセットパスワード',
                subTitle: '2. ログイン関連',
                title: '2.2 リセットパスワード',
                reset: 'パスワードのリセットは、ユーザープロフィールページまたはログイン画面にて行うことができます。',
                resetDetail01: '',
                resetDetail02: '1. ユーザープロフィールページからパス ワードの変更を行う場合',
                resetDetail03: '画面右上のユーザープロフィールアイコンを クリックします。',
                resetDetail032: 'ユーザープロフィールページで「ユーザー設 定」タブを開き、「パスワードをリセットす る」をクリックします。\nクリックすると、一度強制的にログアウトします。',
                resetDetail04: 'パスワード再設定用のフォームが表示されま す。メールアドレスを入力し、送信をクリックします。',
                resetDetail05: '',
                resetDetail06: '入力したメールアドレスにシステムから確認コードが送られます。',
                resetDetail07: 'メールアドレス、メールにて受信した確認コード、新しく設定するパスワードを入力し ます。',
                resetDetail08: '以上でパスワードの再設定は完了し、新しい パスワードでのログインが可能になります。',
                resetDetail09: '',
                resetDetail10: '2. ログイン画面からパスワードの変更を行う場合',
                resetDetail11: 'パスワードを忘れたなどの理由でログインができない場合、ログイン画面の「パスワードをお忘れですか?」から再設定を行います。',
                resetDetail12: 'ログイン画面に表示される「パスワードをお忘れですか?」をクリックしてください。',
                resetDetail13: 'パスワード再設定用のフォームが表示されるため、メールアドレスを入力し、送信をクリックします。',
                resetDetail14: '入力したメールアドレスにシステムから確認コードが送られます。',
                resetDetail15: 'メールアドレス、メールにて受信した確認コード、新しく設定するパスワードを入力し ます。',
                resetDetail16: '以上でパスワードの再設定は完了し、新しいパスワードでのログインが可能になります。',
                resetDetail17: '注意: パスワードは大文字・小文字・数字・下記の記号を含む必要があります。 使用可能な記号の一覧: = + - ^ $ * . [ ] { } ( ) ? ” ! @ # % & / \ , > < \' : ; | _ ~ `',
                resetDetail18: 'また、アカウント発行時に送られるwelcome mailに記載の初期パスワードは、発行から30日を過ぎ ると無効となるため、それまでにログイン/パスワードの変更を行わないと再発行が必要となります。 ※JOMCアカウントをお持ちの場合はwelcome mailは送られず、JOMCのアカウント情報でログイン できます)'
            },
            logout: {
                menuHeader: 'ユーザーログアウト',
                subTitle: '2. 使⽤者の認証',
                title: '2.3 ユーザーログアウト',
                logoutDetail01: "ユーザープロフィールアイコンをクリックします。",
                logoutDetail02: "ユーザープローフィールページで「ユーザー設定」タブを開き、「ログアウト」をクリックします。",
                logoutDetail03: "クリックすると、一度強制的にログアウトされます。",
            },
            navigation: {
                menuHeader: 'メニューナビゲーション',
                title: '3 メニューナビゲーション',
                navigationDetail01: '基本的なナビゲーション',
                navigationDetail02: 'ナビゲーションは２種類あります。 左にある「サイドバー」と 「ナビゲーション メニュー」です。\n「サイドバー」にはユーザーの基本情報やお問い合わせフォームが常時表示されます。\n\n「ナビゲーションメニュー」は以下をご確認ください。',
                dashboardDescription: '総合ページ　（よく利用される機能へのリンク）',
                downloadDescription: '利用許可申請の一覧や、受信した利用許可依頼の一覧',
                uploaddDescription: '素材のアップロード',
                userGuidedDescription: 'Webマニュアル',
                myBagDescription: '個⼈で作成したバッグの一覧',
                galleryscription: '素材の検索',
                adminDescription: 'ユーザー(ユーザー作成、削除), 組織 (組織作成、編集、削除)',
                profileDescription: '登録中のユーザー情報の表示、言語選択、ログアウト',
                myBag: 'My バッグ',
                assetGallery: 'アセットギャラリー',
                adminPage: '管理メニュー（Adminのみ）',
                profilePage: 'ユーザープロフィール',
            },
            upload: {
                menuHeader: '素材のアップロード',
                title: '4.　アップロード',
                step1: {
                    subTitle: '4 素材のアップロード',
                    title: '4.1 アップロードへのリンク',
                    intro: 'アップロードは２種類のリンクから遷移できます。',
                    method1: 'ナビゲーションメニューの「アップロード」から。',
                    method2: 'ダッシュボードページの「アップロード」から。',
                    img1: 'https://asset.japan.travel/image/upload/w_600,f_auto,fl_lossy,e_improve,e_sharpen/v1611168942/dam-admin/manual/Upload/dam_upload_01b.png',
                },
                step2: {
                    subTitle: '4 素材のアップロード',
                    title: '4.2 素材の登録先を選択',
                    amedments: '素材の登録先・素材の入手元を選択し、「次へ」 をクリックします。(キャプチャ2)\n「次へ」のボタンを押すと、キャプチャ3の画面 が表示されます。',
                    amedments2: 'キャプチャ2',
                    amedments3: 'キャプチャ3',
                },
                step3: {
                    subTitle: '4 素材のアップロード',
                    title: '4.3 素材をアップロード',
                    explanations1: '素材は、画面中央の白い枠に「ドラッグ&ドロップ」して追加、または「ファイルを追加する」ボタンをクリックして追加することができます。',
                    notesTitle: '注意:',
                    notes1: '素材は個別のファイルとzipファイルの両方で アップロードが可能ですが、両方のタイプのファイルを同時にドロップした場合、zipファイルのみが送付されます。ご注意ください。',
                    explanations2: '素材を追加すると、次のような画面が表示されるので、追加したいすべての素材が表示されているか確認し「次へ」ボタンをクリックします。',
                },
                step4: {
                    subTitle: '4 素材のアップロード',
                    title: '4.4 素材情報の登録',
                    explanations1: '次に素材のファイル名や、情報を入力するエ クセルファイルをダウンロードします。「テンプレートのダウンロード」をクリックし、 テンプレートをダウンロードしてください。\nダウンロードされたエクセルファイルに記載 されている説明に従い、素材の情報を入力してください。',
                    explanations2: '*ファイル名以外の項目は、システムにエク セルファイルをアップロード後、入力・修正 が可能です',
                    notesTitle: '注意：',
                    notes1: '素材のファイル名はアップロード後に 変更ができないため、類似画像と判別できる よう、お気をつけください。',
                    explanations3: 'エクセルを追加すると、次のような画面が表示されます。「次へ」ボタンをクリックします',
                },
                step5: {
                    subTitle: '4 素材のアップロード',
                    title: '4.5 素材情報の登録',
                    explanations1: '入力が必須なフィールドや、エクセル入力時 に記入漏れがあったフィールドはピンク色でハイライトされ、表の上部に赤字でコメントが表示されます。',
                    explanations2: 'ハイライトされたフィールドはクリックする と編集可能です。またコピー&ペーストなど の機能も使用可能です。',
                    explanations3: 'フィールド名の横に「*」があるものは必須項 目です。',
                    explanations4: '各項目のヘッダー部分をクリックすると、 アップロードする素材を並び順をソートすることができます。',
                    explanations5: '例：ファイル名でソートした場合。',
                    explanations6: '「Filter Rows」をクリックすると、フィルターを適用することが可能です。',
                    notesTitle: 'ポイント：',
                    notes1: '多数の素材をアップロードするなど、編集作業を数回に分けて行う場合は、「エクセルを ダウンロード」をクリックすることで、編集途中のエクセルファイルをダウンロードし、後ほど作業を再開することも可能です。',
                    explanations7: '入力作業が完了した後に「保存」ボタンをクリックし、素材のアップロード作業は完了です。 前のステップに戻り、修正したい場合は「戻る」ボタンをクリックします。',
                },
            },
            assets: {
                menuHeader: '素材',
                title: '5. 素材',
                body: '素材とはJNTO Photo & Video Library上で管理される画像(jpeg, png, jpg etc) あるいはビデオ(mp4)を指します。\nユーザーグループによって閲覧できる素材が異なります。\nユーザーグループの設定は管理者が⾏います。',
                assetsDetails: {
                    menuHeader: '5.1 素材',
                    subTitle: '5. 素材',
                    title: '5.1 素材の詳細情報',
                    detail01: '素材とはJNTO Photo & Video Library上で管理される画像(jpeg, png, jpg) あるいは動画(mp4)を指します。',
                    detail02: 'ユーザーはさまざまな方法で素材を管理できます:',
                    detail03: '',
                    detail04: '複数のマイバッグを作成し、素材のダウンロードが可能です',
                    detail05: '事前利用許諾が必要な素材は、利用許可を申請後、担当部から連絡が届きます。流れに沿って手続きを行ったあと、ダウンロードが可能です。',
                    detail06: '都道府県など、フィルターに表示されている様々な項目から素材を絞り込めますs',
                    detail07: '素材の付属情報やタグの追加、編集、削除は素材の担当部に所属するアカウントのみ可能です。編集 権限がある場合は、サムネイルをクリックした後表示される画像下に「編集」と表示されます。この 「編集」をクリックすると複数項目が表示され、素材詳細の編集を行うことできます。',
                    notes: '注意:',
                    notes1: 'システム内の素材を削除できるのは、素材の担当部に所属するアカウントのみです',
                    notes2: '動画と画像の両方をダウンロードする場合はそれぞれ別々にダウンロードを行ってください',
                    notes3: '大量の素材をダウンロードする場合は、エラーを防ぐため複数回に分割して行ってください',
                },
                assetsGallery: {
                    menuHeader: '5.2 アセットギャラリー',
                    subTitle: '5. 素材',
                    title: '5.2 アセットギャラリー',
                    intro: '閲覧権限のある素材はすべて「アセットギャラリー」でご確認いただけます。 ',
                    detail01: '「アセットギャラリー」のページでは検索バー、オプ ションによるソート、JNTO/JOMCのフィルタリングを利用した素材の検索、フィルター配下に表示されている10項目のソートを利用し、素材の絞り込みが可能です。',
                    detail02: '1.「検索バー」: 一つまたは複数のキーワードによる検 索が可能です。',
                    detail03: '2. 「オプションによるソート」: 素材は更新順、ファイ ルサイズ、ファイル名、ダウンロード数で並べ替えるこ とが可能です。',
                    detail04: '',
                    detail05: '3.「JNTO/JOMC」: JNTO Photo & Video Libraryにのみ 登録されている素材、 Japan Online Media Center (JOMC)との両方に登録されている素材を対象に絞り 込みが可能です。',
                    detail06: 'それぞれ「JNTO」「JOMC」のラジオボタンをクリックしご活用ください。',
                    detail07: '4. 「フィルター」: 素材の種類、画像比、都道府県、季節、利用許可申請が必要か否かをはじめ、コンテンツ管理ID等、10項目の要素から素材の絞り込みが可能です。 それぞれの項目から複数の条件で絞り込むことができま す。',
                    detail08: '各素材のサムネイルには名前、都道府県、コンテンツ管理IDが表示されます。素材の詳細を見る場合は、サムネイルをクリックしてください。また、「VIEW MORE DETAILS」をクリックすることで、さらに詳しい素材情報の表示が可能です。\n ※素材を利用する際は素材の編集可否、クレジット表記などの情報を必ずご確認ください。',
                    detail09: '素材の付属情報としてタグが付与されている場合は、「⻘」また「オレンジ」で表示されます。「⻘ (マニュアルタグ)」は手動で管理者が登録したタグです。「オレンジ(オートタグ)」は素材をアップロードする際に自動で付与されたタグです。',
                    detail10: '確認できる詳細情報:',
                    detail11: '利用許諾申請が必要か否か(申請が必要な素材は「鍵アイコン」が表示)',
                    detail12: '画像名、撮影地、都道府県、各種二次利用の可否',
                    detail13: 'タグ(「マニュアルタグ」は⻘色、「オートタグ」はオレンジ色で表示される)',
                    detail14: 'その他詳細情報等の項目は、下記画像の右側部分から確認できます',
                    detail15: '下記画像サムネイル下の「編集」は情報の編集権限がある場合のみ表示されます',
                    detail16: '・タグの削除',
                    detail17: 'タグの右上隅にある「x」ボタンをクリックすること で、素材のタグを削除できます。',
                    detail18: '・タグの追加',
                    detail19: '「タグを追加」ボタンをクリックすることで、新しい タグを追加することができます。クリックするとタグ の入力フィールドが表示されるので、テキストを入力 します。Enterを押下するとタグが保存されます。',
                    detail20: '素材情報の編集方法は2通りあり、素材の担当部に所属しているアカウントのみが編集を行うことがで きます。',
                    detail21: '編集権限がある場合はアセットギャラリーのサムネイル上に「鉛筆マーク」、サムネイルをクリックし た後に表示されるウィンドウの画像下に「編集ボタン」が表示されます。「鉛筆マーク」または「編 集」をクリックすると3のような情報編集項目が表示され、こちらから素材情報の編集が可能です。情 報を編集後、赤色の「UPDATE」ボタンをクリックし内容を更新します。',
                    detail22: '素材のCloudinary URLを取得できます。素材の サムネイル画像にカーソルを合わせ、右上隅の 外部リンクアイコンをクリックしてください。',
                    detail23: 'JNTO Photo & Video Libraryに登録されている素材は2種類に分類されます。',
                    detail24: '1. 利用許可申請が不要な素材(即時ダウンロード可能)',
                    detail25: '2. 利用許可申請が必要な素材',
                    detail26: '「利用許可申請」が必要な場合、素材のサムネイルに「鍵アイコン」が表示されます。この素材は、 即時ダウンロードができず、利用(ダウンロードを含む)にあたり「利用許可申請」を行い、素材の 担当部の許可を得る必要があります。',
                    detail27: '利用許可申請が不要な素材は、1枚単位でダウンロー ドすることができます。1枚のダウンロードの場合 はバッグに入れる必要はなく、直接ダウンロードが 可能です。アセットギャラリーから必要な素材を選 択し「ダウンロード」をクリックします。',
                    detail28: '複数素材を一括ダウンロードするには、マイバッグに 素材を保存する必要があります。素材のグリッドに表 示されるチェックボックスをクリックすると、「選択 した素材をバッグに入れる」が表示され、My バッグ を選ぶよう促されます。利用許可申請が必要/不要に 関わらず、素材をダウンロードする際は、My バッグ に格納し、ダウンロードする必要があります。 注意:大量の素材をダウンロードする場合は複数回に 分割して行うと、エラーの発生を防ぐことができます。 また、動画と画像の両方をダウンロードする場合は素 材のタイプを分けて行うようにしてください。',
                    detail29: '一般ユーザーは、自身の所属する組織が管理する素材 のみを削除することができます。管理者ユーザーは全 ての素材に対して削除する権限が与えられています。',
                    detail30: '素材の削除を行いたい場合、右の画面に表示されてい る削除ボタンをクリックしてください。',
                    label1: 'アセットギャラリー基本操作',
                    label2: '素材の詳細情報の確認',
                    label3: '素材タグの編集',
                    label4: '素材情報の編集',
                    label5: '素材のリンクを取得する (管理者限定機能)',
                    label6: '素材の利用許可申請',
                    label7: '素材のダウンロード',
                    label8: '素材のMyバッグへの保存',
                    label9: '素材の削除',
                    label10: '',



                },
                assetsEdit: {
                    menuHeader: '5.3 素材の詳細:　編集・詳細情報',
                    subTitle: '5. 素材',
                    title: '5.3 素材の詳細:　編集・詳細情報',
                    intro01: '各素材のサムネイルには名前、都道府県、サイズが表⽰されます。素材の詳細をする場合は、サムネイルをクリックしてください。 ',
                    intro02: '素材の付属情報としてタグが付与されている場合は、「青」また「オレンジ」で表示されます。「青（マニュアルタグ）」は手動で管理者が登録したタグです。\n「オレンジ（オートタグ）」は素材をアップロードする際に自動で付与されたタグです。\n確認できる詳細な情報︓',
                    intro03: 'タグ︓ 「青（マニュアルタグ）」は⻘⾊、「オレンジ（オートタグ）」はオレンジ⾊で表⽰される',
                    intro04: '画像名、撮影地、都道府県、各種⼆次利用の可否',
                    intro05: '利用許諾が必要かどうか',
                    detail01Title: '素材タグの編集',
                    detail01: 'タグの削除',
                    detail02: 'タグの右上隅にある「x」ボタンをクリックすることで、素材のタグを削除できます。',
                    detail03: 'タグの追加',
                    detail04: '「タグを追加」ボタンをクリックすることで、新しいタグを追加することができます。\nクリックするとタグの入力フィールドが表示されるので、テキストを入力します。Enterを押下するとタグが保存されます。',
                    detail05Title: '素材のリンクを取得する (管理者限定機能)',
                    detail05: '管理者ユーザーは、素材のCloudinary URLを取得できます。\n素材のサムネイル画像にカーソルを合わせ、右上隅の外部リンクアイコンをクリックすることで取得できます。',

                },
                assetsDelete: {
                    menuHeader: '5.4 素材の削除',
                    subTitle: '5. 素材',
                    title: '5.4 素材の削除',
                    detail01: '1. 一般ユーザーは、自分でアップロードしたアセットのみを削除することができます。管理者ユーザーは全ての素材に対して削除する権限が与えられていますので、取り扱いには十分ご注意ください。 ',
                    detail02: '素材の詳細を表示し、「削除」ボタンをクリックします。',
                    detail03: '2. 以下のような確認画面が表示されますので、内容を確認し問題なければ「OK」をクリックします。',
                    detail04: '3. クリックすると削除の処理が実行されます。（削除には数十秒かかる場合があります。）',
                    detail05: '4. 以上で削除は完了です。'
                },
            },
            myBag: {
                menuHeader: 'My バッグ',
                subTitle: '6. My バッグ',
                title: '6. My バッグ',
                note: '注意:',
                intro: 'ダウンロードする素材は「My バッグ」単位で管理されています。「My Bag」はユーザーが自分で作成することができ、ダウンロードしたい素材を集めて管理や一括ダウンロード、さらに「利用許可申請」を行うことが可能です。',
                create: {
                    menuHeader: 'My バッグの作成',
                    title: '6.1 My バッグの作成',
                    detail01: 'My バッグは、ダウンロードしたい素材を集め管理をしたり、ダウンロードを行うことができます。「利用許可申請」を行う際にもMy Bag単位で管理されます。',
                    detail02Title: 'My バッグの作成方法は２種類あります:',
                    detail02: '「アセットギャラリー」で素材のグリッドからチェックボックをクリックすると作成を促されます。',
                    detail03: '「利用許可申請」をする際に、作成を促されます。',
                    note01Detail: 'My Bagに１つでも「利用許可申請」が必要な素材が入っている場合、そのフォルダーは「利用許可申請」用に使用されます。お使い頂く分には、他のMy バッグと変わりはありませんが、My バッグの一覧で表示した際、「利用許諾画像あり」と表示されます。My バッグは素材１枚から作成することが可能です。',
                    detail04: 'My バッグを作成するには、まず素材を選択します。',
                    detail05: '操作方法: 素材のグリッドに表示されるチェックボックスにチェックをいれると選択されます。',
                    detail06: '素材を選択すると、「新しくMy バッグを作成」するか「既存のバッグ」を選択するかを求められます。',
                    note02Detail: '「利用許可申請」が必要な素材を既存のバッグに追加する際、バッグ内の素材の利用用途、使用目的が同じであるとみなされます。',
                    detail07: '既存のバッグに素材を追加すると、My バッグ画面に遷移します。新しいバッグを作成すると、以下のような画⾯が表⽰されます。\n新しいバッグの名前を⼊⼒し、[Save]ボタンをクリックします。',
                    detail08: '保存ボタンをクリックすると、My バッグページへ遷移します。',
                    detail09: 'すべてのMy バッグを表示するにはナビゲーションメニューにある「MY」バッグアイコンをクリックしてください。'
                },
                edit: {
                    menuHeader: 'My バッグ名の変更',
                    title: '6.2 My バッグ名の変更',
                    intro: 'My バッグページではバッグ名の変更やバッグの削除ができます。',
                    detail01: 'My バッグページに移動します。名前を変更するバッグの鉛筆アイコン（編集）をクリックします。',
                    detail02: '次のような画⾯が表⽰されます。新しいバッグ名を⼊⼒し、[Save]ボタンをクリックすると新しいバッグ名に更新されます。',
                },
                delete: {
                    menuHeader: 'Myバッグの削除',
                    title: '6.3 Myバッグの削除',
                    note01Detail: 'My バッグを削除しても、素材は削除されません。（あくまでもバッグが削除されるだけです）',
                    detail01: 'My バッグの削除には２つの方法あります。',
                    detail02: 'My バッグページから削除',
                    detail03: 'My バッグページに表示されるゴミ箱アイコンで削除をすることができます。',
                    detail04: '次のような画⾯が表⽰されます。「バッグを削除しますか？」と再度質問されるので、内容を確認し、問題なければ「OK」をクリックします。',
                    detail05: 'バッグ詳細ページから削除',
                    detail06: 'バッグの詳細ページに移動します。ページの上部にある「バッグを削除する」ボタンをクリックすると削除ができます。'
                }
            },
            download: {
                menuHeader: '素材のダウンロード　(許可システム)',
                subTitle: '7. ダウンロード',
                title: '7. ダウンロード',
                note: '注意:',
                intro: '素材の一括ダウンロードはMy バッグの詳細ページから行います。ダウンロードを実行すると圧縮ファイル（zip）形式で素材がダウンロードされます。',
                detail01: 'My バッグに「利用許可申請」が必要な素材が含まれている場合、もとから「利用許可」が必要ない素材と＋申請が承認された素材がダウンロードされます。\n「利用許可」を申請中や却下された素材は一括ダウンロードに含まれません。',
                detail02: '「利用許可申請」の詳しい方法はXXXページをご確認ください。',
                detail03: '素材のダウンロード',
                detail04: 'ダウンロードを行うには、必ずMy バッグに登録する必要があります。素材を選択すると、「新しくMy バッグを作成」するか「既存のバッグ」を選択するかを求められます。',
                detail05: '素材には、「利用許可申請」が必要なものと不要な素材があります。',
                detail06: '「利用許可申請」がい必要な素材には「鍵アイコン」が表示されます。',

                step1: {
                    menuHeader: '素材のダウンロード: 利用許可申請不要な素材',
                    title: '7.1 素材のダウンロード(利用許可申請不要な素材)',
                    intro: '利用許可申請が不要な場合は、My バッグの素材を自由にダウンロードすることができます。',
                },
                step2: {
                    menuHeader: '素材のダウンロード',
                    title: '7.2 素材のダウンロード(利用許可申請が必要なもの)',
                    intro: '素材をMy バッグに追加することで、利用許可申請の手続きが可能になります。\n申請を出す場合は「利用許可を申請する」をクリックしてください。',
                    detail01: '以下のような画面が表示され、利用タイプ(商⽤または⾮商⽤)や、素材の利用目的を聞かれるので、テキストを入力してください。',
                    detail02: '入力が完了した「OK」をクリックします。「OK」を押したら申請が提供元に送信されますので、結果が出るまでお待ちください。（結果が出るまでには数日を要する場合があります）。結果が出るまで申請の取り消しや内容の変更はできません。',
                    detail03: '素材の利用許可が承認されると「鍵アイコン」が「解錠アイコン（鍵が開いたアイコン）」に変わります。',
                    detail04: '「利用許可申請」の状況は「利用許可申請」ページでご確認いただけます。内容は「受信した利用許可申請の一覧」と「申請した利用許可の一覧」に分かれます。',
                    detail05: '「受信した利用許可申請の一覧」',
                    detail06: '自分（の組織）が提供元である素材に対する「利用許可」の申請がある場合に表示されます。こちらで、申請の「承認」または「却下」が可能です。',
                    detail07: '回答が必要な利用許可申請がある場合は、ナビゲーションメニュー「利用許可申請」の横に青いアイコンが着きます。',
                    note: '注意:',
                    detail08: '素材をダウンロードする際、利用規約に同意する必要があります。規約をご確認のうえ、一番下までスクロールして頂くと同意の為のチェックボックスが表示されます。チェックを入れて、「OK」をクリックするとダウンロードが開始されます。',
                    detail09: '一度にダウンロードする合計容量が4GBを超える場合は警告が表⽰され、ダウンロードを続⾏するかを尋ねられます。'
                }
            },
            admin: {
                menuHeader: '管理者メニュー　(Admin)',
            }
        },
        dashboard: {
            uploadAssets: 'アップロード',
            downloadRequest: '利用許可申請',
            downloadHistory: 'ダウンロード履歴',
            userGuideDB: 'ユーザーガイド',
            myBag: 'My バッグ',
            faq: 'よくあるご質問',
            imageGallery: 'アセットギャラリー'
        },
        contactForm: {
            title: 'お問い合わせフォーム',
            subject: 'お問い合わせ分類',
            option1: '操作方法に関するお問い合わせ',
            option2: 'バグ報告に関するお問い合わせ',
            option3: 'その他',
            inputfield: 'タイトル',
            message: 'お問い合わせ内容',
            cancel: 'キャンセル',
            send: '送信',
            placeholder: 'こちらに詳細をご記入ください',
            success: 'JNTO Photo & Video Libraryにお問い合わせ頂きありがとうございます。\nご提供頂いた障害レポートはシステム部と共有されました。\n確認次第、サポートチームよりご連絡させて頂きます。'

        }
    }
};
